import { createApp } from 'vue';
import HrApp from './hr-app.vue';
import router from './router';
import store from './store';
import i18next from 'i18next';
import i18nBaseFileEnAu from '@/locales/en-AU.json';
import { datadogLogs } from '@datadog/browser-logs';
import '@deputyapp/copilot2/lib/style.css';
import '@deputyapp/copilot2/lib/variables.css';
datadogLogs.init({
  clientToken: process.env.DATA_DOG_CLIENT_TOKEN,
  site: 'datadoghq.com',
  service: 'web-hr',
  env: process.env.API_ENV,
  sessionSampleRate: 100,
  forwardErrorsToLogs: true,
});

i18next.init({
  lng: 'en-AU',
  ns: ['common'],
  defaultNS: 'common',
  compatibilityJSON: 'v3',
  resources: {
    'en-AU': i18nBaseFileEnAu,
  },
  fallbackLng: {
    'en-AU': ['en'],
    default: ['en-AU'],
  },
  interpolation: {
    escapeValue: false,
  },
});

window.__APP__ = {
  API_ENV: process.env.API_ENV,
  API_OVERRIDE: process.env.API,
  STORE: store,
};

createApp(HrApp).use(store).use(router).mount('#app');
